module.exports = __webpack_public_path__ + "img/fundermax-slider-3.e1e6faae.jpg";